// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinkStyles } from "@guestsupply/Overrides/Widgets/Common/CartLink";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

cartLinkStyles.headerClickable = {
    title: {
        css: css`
            &:hover {
                color: ${color("text.main")};
            }
        `,
    },
    clickable: {
        css: css`
            ${IconWrapper} {
                color: ${color("common.ui1")};
            }
            &:hover,
            &.minicart-open {
                ${TypographyStyle} {
                    color: ${color("text.main")};
                }
                ${IconWrapper} {
                    color: ${color("common.ui9")};
                    path {
                        fill: ${color("common.ui9")};
                    }
                }
            }
        `,
    },
};

cartLinkStyles.tippyPopup = {
    main: {
        css: css`
            &&&.tippy-box {
                padding: 0;
                & > .tippy-content {
                    max-height: calc(100vh - 200px);
                }
            }
        `,
    },
};

cartLinkStyles.lineCountWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        align-items: center;
        position: absolute;
        bottom: 11px;
        left: 15px;
        &.sticky {
            left: 17px;
        }
        ${xScreen("lte", "md")} {
            position: unset;
        }
    `,
};

cartLinkStyles.lineCount = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-top: 2px;
        height: 22px;
        width: 22px;
        background-color: ${color("primary")};
        border-radius: 50%;
        color: ${color("common.ui1")};
        border: 1px solid ${color("common.ui1")};
        font-size: 10px;
        font-weight: bold;
        line-height: 16px;
        letter-spacing: 0;
        line-height: 1;
        &.cart-opened {
            background-color: ${color("common.ui9")};
        }
        ${xScreen("lte", "md")} {
            padding-top: 0;
            margin-right: 0;
            font-size: 13px;
            line-height: 14px;
        }
        ${xScreen("lte", "sm")} {
            font-size: 10px;
            line-height: 16px;
        }
    `,
};
